import { Avatar, Divider } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { CommentConttentAllComments } from './CommentConttentAllComments';

export const AllCommentsCommponentMainShow = ({ comments, user }) => {
  const [comment, setcomment] = useState([]);
  const [commentsales, setcommentsales] = useState([]);

  useEffect(() => {
    if (comments && comments.Comments) {
      setcomment(comments.Comments);
    } else {
      setcomment([]);
    }

    if (comments && comments.leed && comments.leed.sales) {
      setcommentsales(comments.leed.sales);
    } else {
      setcommentsales([]);
    }
  }, [comments]);

  const [filteredComments, setFilteredComments] = useState([]);

  // باقي الدوال كما هي بدون تغيير
  const getCleanImageUrl = (url) => {
    if (!url) return null;
    const parts = url.split('/UsersImages/');
    return parts.length > 2 ? `${parts[0]}/UsersImages/${parts[2]}` : url;
  };

  const profileImage = filteredComments[0]?.sales?.profileImg
    ? getCleanImageUrl(filteredComments[0]?.sales?.profileImg)
    : null;

  return (
    <Container style={{ width: '100%', background: '' }}>
      <Row style={{ marginTop: '10px' }} className="w-100">
        <Col xs={6} md={2}>
          {/* <Avatar
alt={comment[0]&&comment[0].sales?(comment[0].sales.name):null}
src="/static/images/avatar/1.jpg"
sx={{ width: 56, height: 56 }}
/> */}

          <div className="d-flex justify-content-between align-items-start w-100">
            {/* الصورة والاسم */}
            <div className="d-flex align-items-center gap-2">
              <Avatar
                alt={comment[0]?.sales?.name || 'Sales Avatar'}
                src={comment[0] && comment[0].sales ? comment[0].sales.profileImg : null}
                sx={{ width: 40, height: 40 }}
              />
              <div style={{ lineHeight: '1.2' }}>
                <div style={{ fontWeight: '600', fontSize: '16px', color: '#1a1a1a' }}>
                  {comment[0]?.sales?.name}
                </div>
                <div style={{ fontSize: '14px', color: '#6c757d' }}>
                  {comment[0]?.sales?.role || 'Sales'}
                </div>
              </div>
            </div>
          </div>
        </Col>

        {comment
          ? comment.map((item, index) => {
              return (
                <Col xs={12} md={10} style={{ borderRadius: '10px', width: '100%' }}>
                  <CommentConttentAllComments
                    comment={item}
                    commentsales={commentsales}
                    user={user}
                  />
                </Col>
              );
            })
          : null}
        {/* <div className='w-100 d-flex' style={{fontWeight:'bold',fontSize:'20px'}}><PersonOutlineIcon/>{comments.Comments[0].sales.name}</div>
    <div>First Action</div>
    <div className='w-100 d-flex ' style={{color:'royalblue'}}>First : {comments.Comments[0].firstcomment.text}.</div>
    <div className='w-100 d-flex justify-content-center ' style={{color:'royalblue',fontSize:'12px'}}><AccessAlarmsIcon style={{fontSize:'20px'}}/> Created At :  {comments.Comments[0].firstcomment.date} </div>

<hr/>
    <div>Second Action</div>
    <div className='w-100 d-flex ' style={{color:'royalblue'}}>Second :  {comments.Comments[0].secondcomment.text} .</div>
    <div className='w-100 d-flex justify-content-center ' style={{color:'royalblue',fontSize:'12px'}}><AccessAlarmsIcon style={{fontSize:'20px'}}/> Created At :  {comments.Comments[0].secondcomment.date}</div>
*/}

        <Divider style={{ color: '#0F7687' }} />
      </Row>
      <hr style={{ color: '#0F7687', border: '2px solid #0F7687' }} />
    </Container>
  );
};
